import { render, staticRenderFns } from "./UpcomingEventsEditor.vue?vue&type=template&id=62f5a0af&scoped=true&"
import script from "./UpcomingEventsEditor.vue?vue&type=script&lang=js&"
export * from "./UpcomingEventsEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f5a0af",
  null
  
)

export default component.exports